// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill2","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M22 14H14L14 21L17.502 19.4971L22 19.4971V14Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"map-chat"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M22 14H14L14 21L17.502 19.4971L22 19.4971V14Z","mask":"props.overlapMaskUrl_fill2"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15 6.5L9 3L3 6.5V20L9 17.5M15 6.5L21 4V10M15 6.5V10M9 17.5V3.5M9 17.5L10.5 18.375","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M22 14H14L14 21L17.502 19.4971L22 19.4971V14Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MapChatIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'map-chat',
    ref,
    icon: element,
  },
));

MapChatIcon.displayName = 'MapChatIcon';

export default MapChatIcon;
